import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import Moment from 'moment'

import API_BASE from '../../../api/apiBase'
import API_CONFIG from '../../../api/apiConfig'

import { Divider, Tooltip, Popconfirm, Statistic, Alert, List, Card, Table, Form, Radio, Input, InputNumber, Select, TreeSelect, Switch, DatePicker, Button, Space, notification, Tabs, Typography, Upload, message, Row, Col, Image } from 'antd'
import { InfoCircleOutlined, DoubleLeftOutlined, LoadingOutlined, PlusOutlined, EditOutlined, DeleteOutlined, DownloadOutlined } from '@ant-design/icons'

import languageManager from '../../../services/languageManager'
import * as storeActions from './store/actions/products'

import Loader from '../../common/PageElements/Loader'
import { startLoading, endLoading, download } from '../../../shared/utility'

import SelectCategory from '../categories/widget/SelectCategory'
import CreateCategoryDrawer from '../categories/widget/CreateCategoryDrawer'

import CreateVariationDrawer from './widget/CreateVariationDrawer'
import CreateStockDrawer from './widget/CreateStockDrawer'
import ProductMarketplaceCard from './widget/ProductMarketplaceCard'

import DragSortingUpload from './store/utilities/dragSorting.js'
import SpecificsSelect from './store/utilities/specificsSelect'
import TabPrices from './store/utilities/tabPrices'



function getBase64(img, callback) {
   const reader = new FileReader();
   reader.addEventListener('load', () => callback(reader.result));
   reader.readAsDataURL(img);
}

// function beforeUpload(file) {
//    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
//    if (!isJpgOrPng) {
//       message.error('You can only upload JPG/PNG file!');
//    }
//    const isLt2M = file.size / 1024 / 1024 < 2;
//    if (!isLt2M) {
//       message.error('Image must smaller than 2MB!');
//    }
//    return isJpgOrPng && isLt2M;
// }

class ProductsEdit extends Component {

   state = {
      isCustomer: !_.isNil(this.props.authState.userData.account.parent_account_id),
      action: undefined,
      itemId: null,
      saveAndClose: false,
      pageLoader: true,
      formLoader: false,
      loaderAddFiles: false,
      loadersFiles: false,
      loaderOrderSave: false,
      loaderImageDelete: false,
      loaderAddImages: false,
      loaderAddImageFromUrl: false,
      loadersStocks: [],
      loadersVariations: [],
      loadersVariationImage: [],
      formValues: {
         categories: [],
         marketplace_sync: []
      },
      componentLanguage: this.props.authState.defaultLanguage,
      categories_tree: [],
      tax_rates: [],
      suppliers: [],
      file_types: [],
      actual_file_type_id: null,
      fileUploadList: [],
      fileUploadWarnings: [],
      imageUploadList: [],
      imageUploadUrl: '',
      imageUploadWarnings: [],
      price_management_date_range: false,
      imageUrl: "",
      uploadLoading: false,
   };
   formRef = React.createRef();

   // static getDerivedStateFromProps(props, state) {
   //    if (props.action === 'edit') {
   //       const formValues = {
   //          id: props.itemData.id,
   //          name: props.itemData.name.it,
   //          percentage: props.itemData.percentage,
   //          language: 'it'
   //       }
   //       return updateObject(state, { formValues: formValues });
   //       // state.initial_values.name = props.itemData.t_name;
   //       // state.initial_values.percentage = props.itemData.percentage;
   //    }

   //    return state;
   // }

   setForm = (response, lang = this.state.componentLanguage) => {
      // let tag_ids = response.tag_ids
      // _.forEach(tag_ids, (tag_id, i) => {
      //    tag_ids[i] = tag_id.toString()
      // });

      const values = {
         parent_id: response.parent_id,
         parent_name: response.parent ? response.parent.name[lang] : 'Prodotto padre',
         product_type: response.is_parent ? 'variable' : 'simple',
         price_on_variation: response.price_on_variation ? true : false,
         price_on_request: response.price_on_request ? true : false,
         supplier_id: response.supplier_id,
         supplier_sku: response.supplier_sku,
         sku: response.sku,
         ean: response.ean,
         upc: response.upc,
         gtin: response.gtin,
         name: response.name,
         brand_id: response.brand_id,
         category_ids: response.category_ids,
         categories: response.categories,
         main_category_id: response.main_category_id,
         // intro: response.intro[lang],
         description: response.description,
         file_list: response.file_list,
         gallery: response.gallery,
         manage_quantity: response.manage_quantity ? true : false,
         always_available: response.always_available ? true : false,
         use_stocks: response.use_stocks ? true : false,
         stocks: response.stocks,
         warehouse: response.warehouse,
         quantity: response.quantity,
         last_quantity_update: _.isNil(response.quantity_updated_at_human) ? 'MAI' : response.quantity_updated_at_human,
         price_buy_no_vat: response.price_buy_no_vat,
         price_retail_no_vat: response.price_retail_no_vat,
         tax_rate_id: response.tax_rate_id,
         pieces_per_pack: response.pieces_per_pack,
         weight: response.weight,
         length: response.length,
         height: response.height,
         width: response.width,
         tag_ids: response.tag_ids,
         specifics: response.specific_values,
         is_parent: response.is_parent,
         variations: response.variations,
         // is_visible: response.visible[lang],
         language: lang,
         image: response.image
      }
      return values;
   }

   getItem = (id) => {
      return storeActions.getItem(id)
         .then(response => {
            console.log(response);
            try {
               const updatedValues = this.setForm(response.data);
               // console.log(updatedValues)
               this.setState({ response: response.data, formValues: updatedValues });
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
            }
         }).catch((e) => {
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   getComplements = () => {
      return storeActions.getProductComplements()
         .then(response => {
            console.log(response);
            try {
               this.setState({
                  response: response,
                  categories_tree: response.categoriesTree,
                  tax_rates: response.taxRatesList,
                  suppliers: response.suppliersList,
                  // tags_list: response.tagsList,
                  // specifics: response.specificsList,
                  // file_types: response.fileTypesList,
               });

            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   componentDidMount() {
      if (this.props.match.params.id) {
         const itemId = this.props.match.params.id
         Promise.all([
            this.getItem(itemId),
            this.getComplements()
         ]).then(() => {
            this.setState({
               action: 'edit',
               itemId: itemId,
               pageLoader: false
            });
         });
      }
      else {
         const formValues = {
            language: this.state.componentLanguage,
            categories: [],
            gallery: [],
            product_type: 'simple',
            manage_quantity: true,
            price_on_request: false,
            supplier_id: this.state.isCustomer ? this.props.authState.userData.account.id : null,
         }
         Promise.all([
            this.getComplements()
         ]).then(() => {
            this.setState({
               formValues: formValues,
               action: 'insert',
               pageLoader: false
            });
         });
      }
   }

   confirmHandler = (onConfirm, itemId, productId = null) => {
      switch (onConfirm) {
         case 'deleteFile':
            if (itemId) {
               this.handleDeleteFile(itemId);
            }
            break;
         case 'deleteStock':
            if (productId, itemId) {
               this.deleteStockHandler(productId, itemId);
            }
            break;
         case 'deleteVariation':
            if (itemId) {
               this.deleteVariationHandler(itemId);
            }
            break;
         default:
            break;
      }
   }

   handleResetForm = () => {
      this.setState({ formLoader: true })
      if (this.state.itemId) {
         Promise.all([
            this.getItem(this.state.itemId)
         ]).then(() => {
            this.setState({ formLoader: false });
         });
      }
      else {
         this.setState({
            formValues: {
               categories: [],
               gallery: [],
               product_type: 'simple',
               manage_quantity: true,
               price_on_request: false,
            }, formLoader: false
         });
      }
   }

   handleSaveAndClose = () => {
      this.setState({ saveAndClose: true });
      console.log(this.state);
   }


   generateSku = () => {
      const supplier_sku = this.formRef.current.getFieldValue('supplier_sku')
      if (!_.isNil(supplier_sku)) {
         const supplier_id = this.formRef.current.getFieldValue('supplier_id')
         console.log('Actual form values', supplier_id)
         let supplier_code = _.isNil(supplier_id) ? '0000' : supplier_id.toString().padStart(4, '0');
         const new_sku = 'B2B' + supplier_code + '-' + this.formRef.current.getFieldValue('supplier_sku');
         console.log('Nuovo SKU generato', new_sku);
         this.formRef.current.setFieldValue('sku', new_sku.toUpperCase());
      }
   }

   handleProductTypeChange = (e) => {
      console.log(e.target.value)
      let newValues = { ...this.state.formValues }
      switch (e.target.value) {
         case 'simple':
            newValues.is_parent = false
            break
         case 'variable':
            newValues.is_parent = true
            newValues.variations = _.isNil(newValues.variations) ? [] : newValues.variations
            break
      }
      this.setState({ formValues: newValues })
   }
   handlePriceTypeChange = (e) => {
      console.log(e.target.value)
      let newValues = { ...this.state.formValues }
      newValues.price_on_variation = e.target.value
      this.setState({ formValues: newValues })
   }
   handlePriceOnRequestChange = (e) => {
      console.log(e.target.value)
      let newValues = { ...this.state.formValues }
      newValues.price_on_request = e.target.value
      this.setState({ formValues: newValues })
   }

   // onParentChange = value => {
   //    console.log(value);
   //    this.setState({ value });
   // };
   onCreateCategoryFinish = values => {
      console.log("Create category", values);
   }
   onCreateCategoryFinishFailed = errorInfo => {
      notification.error({
         message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
         description: languageManager.getMessage(this.props.commonState, 'notification.error.formInvalid'),
      })
   };

   onFinish = values => {
      console.log(this.state.formValues.specifics);
      console.log(this.state);
      values.id = this.state.itemId
      values.specifics = this.state.formValues.specifics
      values.categories = this.state.formValues.category_ids
      // values.tags = this.state.formValues.tag_ids
      console.log(values);
      this.setState({ formLoader: true });
      storeActions.createOrUpdate(values)
         .then(response => {
            console.log(response);
            if (this.state.saveAndClose) {
               this.props.history.goBack();
            }
            const updatedValues = this.setForm(response.data);
            this.setState({ response: response.data, itemId: response.data.id, action: 'edit', formValues: updatedValues, formLoader: false });

            notification.success({
               message: languageManager.getMessage(this.props.commonState, 'notification.confirm.title'),
               description: languageManager.getMessage(this.props.commonState, this.state.action === 'edit' ? 'notification.confirm.updateOk' : 'notification.confirm.insertOk'),
            })

         }).catch((e) => {
            this.setState({ formLoader: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: e.human ? (
                  <List
                     size="small"
                     split={false}
                     dataSource={e.human}
                     renderItem={item => <List.Item>{item}</List.Item>}
                  />
               ) : languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
               duration: 0
            })
         });
   };
   onFinishFailed = errorInfo => {
      notification.error({
         message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
         description: languageManager.getMessage(this.props.commonState, 'notification.error.formInvalid'),
      })
      console.log(errorInfo)
   };

   onVisibleSwitchChange = (checked) => {
      let newFormValues = { ...this.state.formValues }
      newFormValues.is_visible = checked;
      this.setState({ formValues: newFormValues });
   }

   setDefaultLanguageHandler = (value) => {
      console.log(value);
      const updatedValues = this.setForm(this.state.response, value);
      this.setState({ formValues: updatedValues, componentLanguage: value })
   }

   onCategoriesTreeChange = value => {
      console.log('onChange ', value);
      this.setState({ value });
   };

   handleImagesOrderSave = images => {
      console.log('imagesOrderSaveHandler', images)
      this.setState({ loaderOrderSave: true });
      storeActions.saveImagesOrder(this.props.match.params.id, images)
         .then(response => {
            console.log(response);
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.gallery = response.data;
               this.setState({ formValues: newFormValues, loaderOrderSave: false });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               this.setState({ loaderOrderSave: false });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loaderOrderSave: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   };

   handleImageDelete = imageId => {
      console.log('handleImageDelete', imageId)
      this.setState({ loaderImageDelete: true });
      storeActions.deleteImage(this.props.match.params.id, imageId)
         .then(response => {
            console.log(response);
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.gallery = response.data;
               this.setState({ formValues: newFormValues, loaderImageDelete: false });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.deleteOk'),
               })
            } catch (e) {
               this.setState({ loaderImageDelete: false });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loaderImageDelete: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   };


   //PRICE MANAGEMENT
   dateRangeRadioChange = e => {
      console.log('radio checked', e.target.value);
      this.setState({
         price_management_date_range: e.target.value,
      });
   };
   // setPriceOperator = e => {
   //    console.log('Select operator', e.target.value);
   //    this.setState({
   //       price_management_operator: e.target.value,
   //    });
   //    calculateFinalPrice();
   // };
   // setPriceVariation = e => {
   //    console.log('Select variation', e.target.value);
   //    this.setState({
   //       price_management_variation: e.target.value,
   //    });
   //    calculateFinalPrice();
   // };
   // calculateFinalPrice = () => {
   //    if(this.state.price_management_operator && this.state.price_management_variation) {
   //       let base = 10;

   //    }
   // }

   handleUploadChange = info => {
      if (info.file.status === 'uploading') {
         this.setState({ loading: true });
         return;
      }
      if (info.file.status === 'done') {
         // Get this url from response in real world.
         getBase64(info.file.originFileObj, imageUrl =>
            this.setState({
               imageUrl,
               loading: false,
            }),
         );
      }
   };

   handleSaveSpecific = (index, specific) => {
      console.log('save specific', index, specific)
      let newFormValues = { ...this.state.formValues }
      let specifics = this.state.formValues.specifics
      specifics[index] = specific
      newFormValues.specifics = specifics;
      console.log(specifics)
      this.setState({ formValues: newFormValues });
   }

   handleDeleteSpecific = (index) => {
      console.log('delete specific', index)
      let newFormValues = { ...this.state.formValues }
      let specifics = this.state.formValues.specifics
      specifics.splice(index, 1)
      newFormValues.specifics = specifics;
      console.log(specifics)
      this.setState({ formValues: newFormValues });
   }

   addSpecific = () => {
      let newFormValues = { ...this.state.formValues }
      let specifics = this.state.formValues.specifics ? this.state.formValues.specifics : []
      specifics.push(null)
      newFormValues.specifics = specifics;
      this.setState({ formValues: newFormValues });
   }

   handleSelectCategories = (value) => {
      console.log('select categories', value)
      let newFormValues = { ...this.state.formValues }
      newFormValues.category_ids = value;
      this.setState({ formValues: newFormValues });
   }

   handleSaveCustomPrice = (marketplace_id, variation_operator, variation_amount, start_date, end_date) => {
      console.log('handleSaveCustomPrice', marketplace_id, variation_operator, variation_amount, start_date, end_date)
      this.setState({ loaderOrderSave: true });
      storeActions.saveCustomPrice(this.props.match.params.id, marketplace_id, variation_operator, variation_amount, start_date, end_date)
         .then(response => {
            console.log(response);
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.marketplace_prices = response.data;
               this.setState({ formValues: newFormValues, loaderOrderSave: false });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               this.setState({ loaderOrderSave: false });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loaderOrderSave: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   handleAddImages = () => {
      console.log('handleAddImages', this.state.imageUploadList)
      let images = []
      _.forEach(this.state.imageUploadList, (image, index) => {
         images.push(image.response.data.file_path)
      })
      console.log('handleAddImages', images)
      // return false
      this.setState({ loaderAddImages: true })
      storeActions.addImages(this.props.match.params.id, images)
         .then(response => {
            console.log(response);
            this.setState({ loaderAddImages: false })
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.gallery = response.data
               this.setState({ formValues: newFormValues, imageUploadWarnings: response.warnings, imageUploadList: [] })
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loaderAddImages: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   handleImageUploadUrl = (e) => {
      this.setState({ imageUploadUrl: e.target.value });
   }

   handleAddImageFromUrl = () => {
      console.log('handleAddImageFromUrl', this.state.imageUploadUrl)
      this.setState({ loaderAddImageFromUrl: true })
      return false
      storeActions.addImages(this.props.match.params.id, this.state.imageUploadUrl)
         .then(response => {
            console.log(response);
            this.setState({ loaderAddImageFromUrl: false })
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.gallery = response.data
               this.setState({ formValues: newFormValues, imageUploadWarnings: response.warnings, imageUploadList: [] })
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }
         }).catch((e) => {
            this.setState({ loaderAddImageFromUrl: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   handleFileTypeSelect = (value) => {
      this.setState({ actual_file_type_id: value })
   }
   handleAddFiles = () => {
      console.log('handleAddFiles', this.state.fileUploadList)
      let files = []
      _.forEach(this.state.fileUploadList, (image, index) => {
         files.push(image.response.data.file_path)
      })
      console.log('handleAddFiles', files)
      // return false
      this.setState({ loaderAddFiles: true })
      storeActions.addFiles(this.props.match.params.id, files, this.state.actual_file_type_id)
         .then(response => {
            console.log(response);
            this.setState({ loaderAddFiles: false })
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.file_list = response.data
               this.setState({ formValues: newFormValues, fileUploadWarnings: response.warnings, fileUploadList: [] })
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loaderAddFiles: false });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }
   handleDeleteFile = fileId => {
      console.log('handleDeleteFile', fileId)
      this.setState({ loadersFiles: startLoading(this.state.loadersFiles, fileId) });
      storeActions.deleteFile(this.props.match.params.id, fileId)
         .then(response => {
            console.log(response);
            this.setState({ loadersFiles: endLoading(this.state.loadersFiles, fileId) });
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.file_list = response.data;
               this.setState({ formValues: newFormValues });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.deleteOk'),
               })
            } catch (e) {
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loadersFiles: endLoading(this.state.loadersFiles, fileId) });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   };

   showCreateCategoryDrawer = () => {
      this.setState({ showCreateCategoryDrawer: true })
   }
   hideCreateCategoryDrawer = () => {
      this.setState({ showCreateCategoryDrawer: false })
   }
   handleCreateCategory = (categories_tree) => {
      console.log('Categoria creata correttamente')
      this.setState({ categories_tree: categories_tree, showCreateCategoryDrawer: false })
   }

   editVariationHandler = item => {
      this.setState({ createVariationDrawerItem: item, showCreateVariationDrawer: true })
   }
   deleteVariationHandler = itemId => {
      console.log('deleteVariationHandler', itemId)
      this.setState({ loadersVariations: startLoading(this.state.loadersVariations, itemId) });
      storeActions.deleteProductVariation(itemId, true)
         .then(response => {
            console.log(response);
            try {
               let newFormValues = { ...this.state.formValues }
               newFormValues.variations = response.data;
               this.setState({ formValues: newFormValues, loadersVariations: endLoading(this.state.loadersVariations, itemId) });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.deleteOk'),
               })
            } catch (e) {
               this.setState({ loadersVariations: endLoading(this.state.loadersVariations, itemId) });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loadersVariations: endLoading(this.state.loadersVariations, itemId) });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }
   showCreateVariationDrawer = () => {
      if (this.state.itemId) {
         this.setState({ createVariationDrawerItem: null, showCreateVariationDrawer: true })
      } else {
         notification.error({
            message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
            description: languageManager.getMessage(this.props.commonState, 'notification.warning.saveProductBeforeVariation'),
         })
      }
   }
   hideCreateVariationDrawer = () => {
      this.setState({ createVariationDrawerItem: null, showCreateVariationDrawer: false })
   }
   handleCreateVariation = (variations_list) => {
      console.log('Variante creata correttamente')
      var newFormValues = { ...this.state.formValues }
      newFormValues.variations = variations_list
      this.setState({ formValues: newFormValues, createVariationDrawerItem: null, showCreateVariationDrawer: false })
   }

   saveVariationImageHandler = (e) => {
      var itemId = e.target.variationId
      console.log('saveVariationImageHandler', itemId)
      this.setState({ loadersVariationImage: startLoading(this.state.loadersVariationImage, itemId) });
      storeActions.saveVariationImage(itemId, e.target.value)
         .then(response => {
            console.log(response);
            try {
               var newFormValues = { ...this.state.formValues }
               _.forEach(newFormValues.variations, (variation, index) => {
                  if (itemId === variation.id) {
                     variation.images = response.data
                     return false;
                  }
               })
               this.setState({ formValues: newFormValues, loadersVariationImage: endLoading(this.state.loadersVariationImage, itemId) });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               this.setState({ loadersVariationImage: endLoading(this.state.loadersVariationImage, itemId) });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loadersVariationImage: endLoading(this.state.loadersVariationImage, itemId) });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }
   deleteVariationImageHandler = (itemId) => {
      console.log('deleteVariationImageHandler', itemId)
      this.setState({ loadersVariationImage: startLoading(this.state.loadersVariationImage, itemId) });
      storeActions.deleteVariationImage(itemId)
         .then(response => {
            console.log(response);
            try {
               var newFormValues = { ...this.state.formValues }
               _.forEach(newFormValues.variations, (variation, index) => {
                  if (itemId === variation.id) {
                     variation.images = response.data
                     return false;
                  }
               })
               this.setState({ formValues: newFormValues, loadersVariationImage: endLoading(this.state.loadersVariationImage, itemId) });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.updateOk'),
               })
            } catch (e) {
               this.setState({ loadersVariationImage: endLoading(this.state.loadersVariationImage, itemId) });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loadersVariationImage: endLoading(this.state.loadersVariationImage, itemId) });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }

   manageQuantityHandler = (checked) => {
      console.log(checked)
      var newFormValues = { ...this.state.formValues }
      newFormValues.manage_quantity = checked
      console.log(checked, newFormValues)
      this.setState({ formValues: newFormValues });
   }
   useStocksHandler = (checked) => {
      var newFormValues = { ...this.state.formValues }
      newFormValues.use_stocks = checked
      this.setState({ formValues: newFormValues });
   }

   editStockHandler = (productId, item) => {
      this.setState({ stockDrawerProductId: productId, createStockDrawerItem: item, showCreateStockDrawer: true })
   }
   deleteStockHandler = (productId, itemId) => {
      console.log('deleteStockHandler', itemId)
      this.setState({ loadersStocks: startLoading(this.state.loadersStocks, itemId) });
      storeActions.deleteProductStock(itemId)
         .then(response => {
            console.log(response);
            try {
               var newFormValues = { ...this.state.formValues }
               if (productId === this.state.itemId) {
                  newFormValues.stocks = response.data
               } else {
                  _.forEach(newFormValues.variations, (variation, index) => {
                     if (productId === variation.id) {
                        variation.stocks = response.data
                        return false;
                     }
                  })
               }
               this.setState({ formValues: newFormValues, loadersStocks: endLoading(this.state.loadersStocks, itemId) });
               notification.success({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.confirm.deleteOk'),
               })
            } catch (e) {
               this.setState({ loadersStocks: endLoading(this.state.loadersStocks, itemId) });
               notification.error({
                  message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
                  description: languageManager.getMessage(this.props.commonState, 'notification.error.clientError'),
               })
               if (this.props.commonState.debug) console.log(e);
            }

         }).catch((e) => {
            this.setState({ loadersStocks: endLoading(this.state.loadersStocks, itemId) });
            notification.error({
               message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
               description: languageManager.getMessage(this.props.commonState, 'notification.error.serverError'),
            })
            if (this.props.commonState.debug) console.log(e);
         });
   }
   showCreateStockDrawer = (productId) => {
      if (this.state.itemId) {
         this.setState({ stockDrawerProductId: productId, createStockDrawerItem: null, showCreateStockDrawer: true })
      } else {
         notification.error({
            message: languageManager.getMessage(this.props.commonState, 'notification.warning.title'),
            description: languageManager.getMessage(this.props.commonState, 'notification.warning.saveProductBeforeStock'),
         })
      }
   }
   hideCreateStockDrawer = () => {
      this.setState({ createStockDrawerItem: null, showCreateStockDrawer: false })
   }
   handleCreateStock = (productId, stocksList) => {
      console.log('Quantità in magazzino creata correttamente')
      var newFormValues = { ...this.state.formValues }
      if (productId === this.state.itemId) {
         newFormValues.stocks = stocksList
      } else {
         _.forEach(newFormValues.variations, (variation, index) => {
            if (productId === variation.id) {
               variation.stocks = stocksList
               return false;
            }
         })
      }
      this.setState({ formValues: newFormValues, createStockDrawerItem: null, showCreateStockDrawer: false })
   }

   render() {
      if (!this.props.authState.userData.languages) return '';
      const { Title, Text } = Typography

      const mainLayout = {
         labelCol: { span: 6 },
         wrapperCol: { span: 18 },
         layout: "horizontal",
      };
      const sideLayout = {
         labelCol: { span: 10 },
         wrapperCol: { span: 14 },
         layout: "horizontal",
      };
      const { TextArea } = Input
      const { Option } = Select
      const { TabPane } = Tabs
      const { RangePicker } = DatePicker

      const scope = this;
      const { Dragger } = Upload;

      const stocksTableColumns = [
         {
            title: 'Lotto', key: 'batch',
            fixed: 'left',
            render: (record) => (
               record.batch
            ),
         },
         {
            title: 'Data di scadenza', key: 'expiration_date',
            width: 150,
            render: (record) => (
               record.expiration_date ? Moment(record.expiration_date).format('L') : ''
            ),
         },
         {
            title: 'Giacenza', key: 'quantity',
            width: 75,
            render: (record) => (
               record.warehouse_quantity
            ),
         },
         {
            title: 'Impegnata', key: 'reserved',
            width: 75,
            render: (record) => (
               record.reserved
            ),
         },
         {
            title: 'Disponibile', key: 'available',
            width: 75,
            render: (record) => (
               (record.warehouse_quantity - record.reserved).toFixed(2)
            ),
         },
         {
            title: 'In arrivo', key: 'ordered',
            width: 75,
            render: (record) => (
               record.ordered
            ),
         },
         // {
         //    title: 'Data di acquisto', key: 'purchase_date',
         //    width: 150,
         //    render: (record) => (
         //       record.purchase_date ? Moment(record.purchase_date).format('L') : ''
         //    ),
         // },
         // {
         //    title: 'Fornitore', key: 'supplier',
         //    render: (record) => (
         //       record.supplier ? record.supplier.name : null
         //    ),
         // },
         {
            title: 'Azioni',
            key: 'actions',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
               <Space>
                  {/* <Tooltip title={languageManager.getMessage(this.props.commonState, 'common.edit')}>
                     <Button type="primary" size='small'
                        disabled={this.state.loadersStocks[record.id]}
                        icon={<EditOutlined />}
                        onClick={() => this.editStockHandler(record.product_id, record)}
                     />
                  </Tooltip> */}
                  <Popconfirm
                     placement="topRight"
                     title={languageManager.getMessage(this.props.commonState, 'common.askDeleteConfirm')}
                     onConfirm={() => this.confirmHandler('deleteStock', record.id, record.product_id)}
                     okText={languageManager.getMessage(this.props.commonState, 'common.yes')}
                     cancelText={languageManager.getMessage(this.props.commonState, 'common.no')}
                  >
                     <Button type="danger" size='small'
                        loading={this.state.loadersStocks[record.id]}
                        icon={<DeleteOutlined />}
                        disabled={record.warehouse_quantity != 0}
                     />
                  </Popconfirm>
               </Space>),
         },

      ];
      const stocksTableLayout = {
         bordered: true,
         ellipsis: true,
         pagination: false,
         size: "small",
         className: 'margin-0-I'
      }
      const stockTable = <Table key='stocks_table' {...stocksTableLayout} columns={stocksTableColumns} dataSource={this.state.formValues.stocks} />
      const warehouseTableColumns = [
         {
            title: 'SKU',
            width: 120,
            key: 'sku',
            fixed: 'left',
            render: (text, record) => (
               record.product_sku
            ),
            sorter: (a, b) => a.product_sku.localeCompare(b.product_sku),
         },
         {
            title: 'Prodotto',
            dataIndex: 'product_name',
            key: 'product_name',
            fixed: 'left',
            // render: (text, record) => (
            //    <Link to={'/purchase_orders/details/' + record.id}>{text}</Link>
            // ),
            sorter: (a, b) => a.product_name.localeCompare(b.product_name),
         },
         {
            title: 'Magazzino',
            width: 200,
            key: 'warehouse',
            render: (text, record) => (
               record.warehouse ? record.warehouse.name : null
            ),
            sorter: (a, b) => {
               a = a.warehouse.name || ''
               b = b.warehouse.name || ''
               return a.localeCompare(b)
            },
         },
         {
            title: 'Lotto',
            width: 150,
            dataIndex: 'batch',
            key: 'batch',
            // render: (text, record) => (
            //    <Link to={'/purchase_orders/details/' + record.id}>{text}</Link>
            // ),
            sorter: (a, b) => {
               a = a.batch || ''
               b = b.batch || ''
               return a.localeCompare(b)
            },
         },
         {
            title: 'Scadenza',
            width: 100,
            key: 'expiration_date',
            render: (text, record) => (
               record.expiration_date ? Moment(record.expiration_date).format('L') : null
            ),
            sorter: (a, b) => {
               a = a.expiration_date || ''
               b = b.expiration_date || ''
               return a.localeCompare(b)
            },
         },
         {
            title: 'Giacenza',
            width: 75,
            key: 'warehouse_quantity',
            render: (text, record) => (
               record.warehouse_quantity
            ),
         },
         {
            title: 'Impegnato',
            width: 75,
            key: 'reserved',
            render: (text, record) => (
               record.reserved
            ),
         },
         {
            title: 'Disponibile',
            width: 75,
            key: 'available',
            render: (text, record) => (
               (record.warehouse_quantity - record.reserved).toFixed(2)
            ),
         },
         {
            title: 'In arrivo',
            width: 75,
            dataIndex: 'ordered',
            key: 'ordered',
            render: (text, record) => (
               record.ordered
            ),
         },
         // {
         //    title: 'Arrivo previsto',
         //    width: 120,
         //    key: 'deliver_request_date',
         //    render: (record) => (
         //       record.deliver_request_date ? Moment(record.deliver_request_date).format('L') : null
         //    ),
         //    sorter: (a, b) => {
         //       a = a.deliver_request_date || ''
         //       b = b.deliver_request_date || ''
         //       return a.localeCompare(b)
         //    },
         // },
      ];
      const warehouseTableLayout = {
         bordered: true,
         ellipsis: true,
         size: "small",
         className: 'table-striped-rows'
      }
      const warehouseTable = <Table key='warehouse_table' {...warehouseTableLayout} columns={warehouseTableColumns} dataSource={this.state.formValues.warehouse} />
      const tabWarehouse = (
         <TabPane tab="Magazzino" key="warehouse_tab">
            {/* <Row gutter={[8, 8]}>
               <Col span={24}>
                  <Space>
                     <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        onClick={() => this.showCreateStockDrawer(this.state.itemId)}
                     >
                        Aggiungi quantità
                     </Button>
                  </Space>
               </Col>
            </Row> */}
            <Row>
               <Col span={24}>
                  {this.state.formValues.is_parent ? warehouseTable : stockTable}
               </Col>
            </Row>
         </TabPane>
      )

      const variationsTableColumns = [
         {
            title: 'Variante',
            key: 'variation',
            fixed: 'left',
            render: (record) => (
               <Space direction='vertical' size='small'>
                  {
                     record.variation_values.map((variation, index) => {
                        return (
                           <Text key={'variation_' + variation.id}>{variation.variation.name[this.state.componentLanguage] + ': ' + variation.name[this.state.componentLanguage]}</Text>
                        )
                     })
                  }
               </Space>
            ),
         },
         {
            title: 'SKU',
            key: 'sku',
            width: 120,
            render: (record) => (
               record.sku
            ),
         },
         {
            title: 'Codice fornitore',
            key: 'supplier_sku',
            width: 200,
            render: (record) => (
               record.supplier_sku
            ),
         },
         {
            title: 'Quantità',
            key: 'quantity',
            width: 100,
            render: (record) => (
               record.manage_quantity ?
                  record.actual_quantity :
                  record.always_available ? 'Disponibile' : 'Non disponibile'
            ),
         },
         {
            title: 'Acquisto (i.e.)', key: 'price_buy_no_vat', width: 120,
            render: (record) => (
               record.price_buy_no_vat ? record.price_buy_no_vat + '€' : ''
            ),
            sorter: (a, b) => a.price_buy_no_vat - b.price_buy_no_vat
         },
         {
            title: 'Listino (i.e.)', key: 'price_sell', width: 120,
            render: (record) => (
               this.state.formValues.price_on_variation ? (
                  record.price_on_request ? 'Su richiesta' : record.price_retail_no_vat ? record.price_retail_no_vat + '€' : ''
               ) : 'Prezzo su padre'
            ),
            sorter: (a, b) => a.price_retail_no_vat - b.price_retail_no_vat
         },
         {
            title: 'Azioni',
            key: 'actions',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
               <Space>
                  <Tooltip title={languageManager.getMessage(this.props.commonState, 'common.edit')}>
                     <Button type="primary" size='small'
                        disabled={this.state.loadersVariations[record.id]}
                        icon={<EditOutlined />}
                        onClick={() => this.editVariationHandler(record)}
                     />
                     {/* <Dropdown.Button type="primary" onClick={() => this.editItemHandler(record.id)} overlay={actionsMenu(record.id)}><EditOutlined /></Dropdown.Button> */}
                  </Tooltip>
                  <Popconfirm
                     placement="topRight"
                     title={languageManager.getMessage(this.props.commonState, 'common.askDeleteConfirm')}
                     onConfirm={() => this.confirmHandler('deleteVariation', record.id)}
                     okText={languageManager.getMessage(this.props.commonState, 'common.yes')}
                     cancelText={languageManager.getMessage(this.props.commonState, 'common.no')}
                  >
                     <Button type="danger" size='small'
                        loading={this.state.loadersVariations[record.id]}
                        icon={<DeleteOutlined />}
                     />
                  </Popconfirm>
               </Space>),
         },

      ];
      const variationsTableLayout = {
         bordered: true,
         ellipsis: true,
         pagination: false,
         size: "small",
      }
      const variationTable = (
         <Table key='variations_table'
            {...variationsTableLayout}
            columns={variationsTableColumns}
            dataSource={this.state.formValues.variations}
            expandable={{
               expandedRowRender: record => (
                  <div className="card-container">
                     <Tabs type='card' size="large">
                        {
                           this.state.formValues.use_stocks ? (
                              <TabPane tab="Magazzino" key="1">
                                 {/* <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                       <Space>
                                          <Button
                                             type='primary'
                                             icon={<PlusOutlined />}
                                             onClick={() => this.showCreateStockDrawer(record.id)}
                                          >
                                             Aggiungi quantità
                                          </Button>
                                       </Space>
                                    </Col>
                                 </Row> */}
                                 <Row>
                                    <Col span={24}>
                                       <Table key='stocks_table_' {...stocksTableLayout} columns={stocksTableColumns} dataSource={record.stocks} />
                                    </Col>
                                 </Row>
                              </TabPane>
                           ) : ''
                        }
                        <TabPane tab="Identificatori" key="2">
                           {
                              record.current_tags && !_.isEmpty(record.current_tags) ? ([
                                 <Text strong>Tags: </Text>,
                                 record.current_tags.map((tag, index) => {
                                    return (
                                       <Text>{tag.title}, </Text>
                                    )
                                 })
                              ]) : null
                           }
                        </TabPane>
                        <TabPane tab="Immagini" key="3">
                           <Space direction='horizontal'>
                              <Title level={5}>Seleziona immagine per la variante</Title>
                              {
                                 this.state.loadersVariationImage[record.id] ?
                                    <Button danger type="text" loading={true}>Salvataggio in corso</Button>
                                    : ''
                              }
                           </Space>
                           <Row gutter={[8, 8]}>
                              <Col span={24}>
                                 <Radio.Group
                                    defaultValue={record.gallery && !_.isEmpty(record.gallery) ? record.gallery[0].id : false}
                                    // value={record.gallery && !_.isEmpty(record.gallery) ? record.gallery[0].id : false}
                                    onChange={this.saveVariationImageHandler} >
                                    {
                                       this.state.formValues.gallery.map((image, index) => {
                                          return (
                                             <Radio
                                                key={'variation_images_' + image.id}
                                                variationId={record.id}
                                                value={image.id} >
                                                <Image width={150} src={image.thumb_1000} />
                                             </Radio>
                                          )
                                       })
                                    }
                                 </Radio.Group>
                              </Col>
                           </Row>
                           <Space direction='horizontal'>
                              {/* <Button
                                 type='danger'
                                 size='small'
                                 icon={<DeleteOutlined />}
                                 onClick={() => this.deleteVariationImageHandler(record.id)}
                              >Cancella selezione</Button> */}
                              {/* <Button
                                 type='primary'
                                 size='small'
                                 icon={<SaveOutlined />}
                              >Salva selezione</Button> */}
                           </Space>
                        </TabPane>
                     </Tabs>
                  </div>
               ),
               // rowExpandable: record => record.name !== 'Not Expandable',
            }} />
      )
      const tabVariations = this.state.formValues.is_parent ? (
         <TabPane tab="Varianti" key="variations_tab">
            <Row gutter={[8, 8]}>
               <Col span={24}>
                  <Space>
                     <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        onClick={this.showCreateVariationDrawer}
                     >
                        Crea nuova variante
                     </Button>
                     <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        disabled={true}
                     >
                        Crea varianti multiple
                     </Button>
                  </Space>
               </Col>
            </Row>
            <Row>
               <Col span={24}>
                  {variationTable}
               </Col>
            </Row>
         </TabPane>
      ) : '';

      const tabAnalysis = (
         <TabPane tab="Analisi" key="analysis_tab">
            <div className="site-statistic-demo-card">
               <Row gutter={[16, 16]}>
                  <Col span={8}>
                     <Card>
                        <Statistic
                           title="Quantità vendute"
                           value={11}
                           precision={0}
                           valueStyle={{ color: '#3f8600' }}
                        />
                     </Card>
                  </Col>
                  <Col span={8}>
                     <Card>
                        <Statistic
                           title="Totale venduto"
                           value={9.3}
                           precision={2}
                           valueStyle={{ color: '#cf1322' }}
                           suffix="€"
                        />
                     </Card>
                  </Col>
                  <Col span={8}>
                     <Card>
                        <Statistic
                           title="Utile prodotto"
                           value={9.3}
                           precision={2}
                           valueStyle={{ color: '#cf1322' }}
                           suffix="€"
                        />
                     </Card>
                  </Col>
                  <Col span={8}>
                     <Card>
                        <Statistic
                           title="Marketplace più venduto"
                           value="Privalia"
                           valueStyle={{ color: '#cf1322' }}
                        />
                     </Card>
                  </Col>
                  <Col span={8}>
                     <Card>
                        <Statistic
                           title="Mese più venduto"
                           value="Marzo 2021"
                           valueStyle={{ color: '#cf1322' }}
                        />
                     </Card>
                  </Col>
               </Row>
            </div>
         </TabPane>
      )

      const radioStyle = {
         display: 'block',
         height: '30px',
         lineHeight: '30px',
      };

      const { uploadLoading, imageUrl } = this.state;

      const normFile = e => {
         console.log('Upload event:', e);
         if (Array.isArray(e)) {
            return e;
         }
         return e && e.fileList;
      };

      const imageUploadProps = {
         name: 'file',
         multiple: true,
         fileList: this.state.imageUploadList,
         // disabled: this.state.draggerDisable,
         action: API_BASE.url + API_CONFIG.appUrls.files.fileImport,
         onChange(info) {
            // scope.setState({ draggerDisable: info.fileList.length });
            console.log("CHANGE: ", info);
            scope.setState({ imageUploadList: [...info.fileList] });
            const { status } = info.file;
            if (status !== 'uploading') {
               console.log(info.file, info.fileList);
               // scope.setState({ imageUploadList: info.fileList });
            }
            if (status === 'done') {
               message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
               message.error(`${info.file.name} file upload failed.`);
            }
         },
      };

      const filesTableColumns = [
         {
            title: 'File',
            key: 'file_name',
            fixed: 'left',
            render: (record) => (
               record.file_name
            ),
            sorter: (a, b) => a.file_name.localeCompare(b.file_name),
         },
         {
            title: 'Tipo file',
            key: 'file_type',
            fixed: 'left',
            width: 150,
            render: (record) => (
               record.file_type
            ),
            sorter: (a, b) => a.file_type.localeCompare(b.file_type),
         },
         {
            title: 'Azioni',
            key: 'actions',
            fixed: 'right',
            align: 'right',
            width: 100,
            render: (text, record) => (
               <Space>
                  <Tooltip title={languageManager.getMessage(this.props.commonState, 'common.edit')}>
                     <Button type="primary" size='small'
                        disabled={this.state.loadersFiles[record.id]}
                        icon={<DownloadOutlined />}
                        onClick={() => download(record.full_path, record.file_name)}
                     />
                  </Tooltip>
                  <Popconfirm
                     placement="topRight"
                     title={languageManager.getMessage(this.props.commonState, 'common.askDeleteConfirm')}
                     onConfirm={() => this.confirmHandler('deleteFile', record.id)}
                     okText={languageManager.getMessage(this.props.commonState, 'common.yes')}
                     cancelText={languageManager.getMessage(this.props.commonState, 'common.no')}
                  >
                     <Button type="danger" size='small'
                        loading={this.state.loadersFiles[record.id]}
                        icon={<DeleteOutlined />}
                     />
                  </Popconfirm>
               </Space>),
         },
      ];
      const filesTableLayout = {
         bordered: true,
         ellipsis: true,
         size: "small",
         pagination: false,
      }
      const fileUploadProps = {
         name: 'file',
         multiple: true,
         fileList: this.state.fileUploadList,
         // disabled: this.state.draggerDisable,
         action: API_BASE.url + API_CONFIG.appUrls.files.fileImport,
         onChange(info) {
            // scope.setState({ draggerDisable: info.fileList.length });
            console.log("CHANGE: ", info);
            scope.setState({ fileUploadList: [...info.fileList] });
            const { status } = info.file;
            if (status !== 'uploading') {
               console.log(info.file, info.fileList);
            }
            if (status === 'done') {
               message.success(`${info.file.name} file uploaded successfully.`);
            } else if (status === 'error') {
               message.error(`${info.file.name} file upload failed.`);
            }
         },
      };

      let form = (
         <Card bordered={false} bodyStyle={{ padding: 0 }}
         // loading={this.state.formLoader}
         >
            <Form
               {...mainLayout}
               id="createProduct"
               name="basic"
               ref={this.formRef}
               initialValues={this.state.formValues}
               onFinish={this.onFinish}
               onFinishFailed={this.onFinishFailed}
            >
               <Row gutter={32}>
                  <Col span={14}>
                     <Form.Item label="Tipo di prodotto" name="product_type"
                        rules={[{ required: true, message: 'Scegli il tipo di prodotto' }]}>
                        <Radio.Group
                           onChange={this.handleProductTypeChange}>
                           <Radio.Button value="simple">Semplice</Radio.Button>
                           <Radio.Button value="variable" disabled>Con varianti</Radio.Button>
                        </Radio.Group>
                     </Form.Item>
                     <Form.Item
                        label="Nome"
                        name="name"
                        rules={[{ required: true, message: 'Inserisci il nome del prodotto' }]}
                     >
                        <Input />
                     </Form.Item>
                     {
                        this.state.isCustomer ?
                           <Form.Item name="supplier_id" noStyle><Input type="hidden" /></Form.Item> : (
                              <Form.Item
                                 label="Fornitore"
                                 name="supplier_id"
                                 rules={[]}
                              >
                                 <Select
                                    showSearch
                                    allowClear
                                    placeholder="Seleziona il fornitore"
                                    optionFilterProp="children"
                                    onChange={this.generateSku}
                                    disabled={this.state.isCustomer}
                                 >
                                    {
                                       this.state.suppliers.map((supplier) => {
                                          return <Option key={supplier.id} value={supplier.id}>{supplier.company}</Option>
                                       })
                                    }
                                 </Select>
                              </Form.Item>
                           )
                     }
                     <Form.Item
                        label="Codice fornitore"
                        name="supplier_sku"
                        rules={[{
                           required: true
                           , message: 'Inserisci un codice valido (sono ammessi solo lettere e numeri)'
                           , pattern: new RegExp(/^[a-zA-Z0-9]+$/i),
                        }]}
                        onChange={this.generateSku}
                     >
                        <Input />
                     </Form.Item>
                     <Form.Item
                        label="SKU"
                        name="sku"
                        rules={[{ message: 'Inserisci il codice SKU' }]}
                     >
                        <Input disabled />
                     </Form.Item>

                     {
                        !this.state.formValues.is_parent ?
                           [
                              <Form.Item
                                 label="EAN"
                                 name="ean"
                                 key='ean'
                                 rules={[{ message: 'Inserisci il codice EAN' }]}
                              >
                                 <Input />
                              </Form.Item>,
                              <Form.Item
                                 label="UPC"
                                 name="upc"
                                 key='upc'
                                 rules={[{ message: 'Inserisci il codice UPC' }]}
                              >
                                 <Input />
                              </Form.Item>,
                           ] : ''
                     }

                     <Form.Item
                        label="Categoria"
                        rules={[]}
                     >
                        <Row gutter={8}>
                           <Col span={14}>
                              <SelectCategory
                                 categoriesTree={this.state.categories_tree}
                                 initialValue={this.state.formValues.category_ids}
                                 onChange={(values) => this.handleSelectCategories(values)}
                                 disabled={this.state.isCustomer}
                              />
                           </Col>
                           <Col span={10}>
                              {

                                 this.state.isCustomer ? null : ([
                                    <Button
                                       type='primary' style={{ width: '100%' }}
                                       icon={<PlusOutlined />}
                                       onClick={this.showCreateCategoryDrawer}
                                    >
                                       Nuova categoria
                                    </Button>,
                                    <CreateCategoryDrawer
                                       visible={this.state.showCreateCategoryDrawer}
                                       onClose={this.hideCreateCategoryDrawer}
                                       onSubmit={(categories_tree) => this.handleCreateCategory(categories_tree)}
                                    />
                                 ])
                              }
                           </Col>
                        </Row>

                     </Form.Item>

                     <Form.Item
                        label="Categoria principale"
                        name="main_category_id"
                        rules={[]}
                     >
                        <Select
                           showSearch
                           placeholder="Seleziona la categoria principale"
                           optionFilterProp="children"
                           disabled={this.state.isCustomer}
                        >
                           {
                              this.state.formValues.categories.map((category) => {
                                 return <Option key={category.id} value={category.id}>{category.name[this.state.componentLanguage]}</Option>
                              })
                           }
                        </Select>
                     </Form.Item>
                     <Form.Item
                        label="Descrizione"
                        name="description"
                        rules={[{ message: 'Inserisci la descrizione' }]}
                     >
                        <TextArea
                           rows={10}
                        />
                     </Form.Item>
                  </Col>
                  <Col span={10}>
                     {/* <Title level={4}>{languageManager.getMessage(this.props.commonState, 'component.products.quantity')}</Title> */}
                     <Form.Item
                        {...sideLayout}
                        label="Gestisci quantità"
                        name="manage_quantity"
                        valuePropName='checked'
                     >
                        <Switch
                           onChange={this.manageQuantityHandler} disabled />
                     </Form.Item>
                     {
                        this.state.formValues.manage_quantity ? (
                           [
                              <Form.Item
                                 {...sideLayout}
                                 label="Gestisci magazzino"
                                 name="use_stocks"
                                 key="use_stocks"
                                 valuePropName='checked'
                              >
                                 <Switch
                                    onChange={this.useStocksHandler} disabled />
                              </Form.Item>,
                              <Form.Item
                                 {...sideLayout}
                                 label="Quantità disponibile"
                                 name="quantity"
                                 key="quantity"
                                 rules={[]}
                              >
                                 <InputNumber step={1}
                                    // disabled={this.state.formValues.is_parent}
                                    disabled={this.state.isCustomer || this.state.formValues.is_parent || this.state.formValues.use_stocks} />
                              </Form.Item>,
                              <Form.Item
                                 {...sideLayout}
                                 label="Ultimo aggiornamento"
                                 name="last_quantity_update"
                                 key="last_quantity_update"
                                 rules={[]}
                              >
                                 <Input
                                    // disabled={this.state.formValues.is_parent}
                                    disabled={true} />
                              </Form.Item>
                           ]
                        ) : (
                           <Form.Item
                              {...sideLayout}
                              label="Disponibilità"
                              name="always_available"
                           >
                              <Radio.Group disabled={this.state.formValues.is_parent}>
                                 <Radio.Button value={true}>Disponibile</Radio.Button>
                                 <Radio.Button value={false}>Non disponibile</Radio.Button>
                              </Radio.Group>
                           </Form.Item>
                        )
                     }

                     {/* <Title level={4}>{languageManager.getMessage(this.props.commonState, 'component.products.price')}</Title> */}
                     {/* <Form.Item
                           label="Prezzo di acquisto tasse escluse"
                           name="price_buy_no_vat"
                           rules={[]}
                        >
                           <InputNumber
                              size="large"
                              // style={"width= '100%'"}
                              formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={value => value.replace(/\€\s?|(,*)/g, '')}
                              onChange={this.onPriceSellNoVatChange}
                           />
                        </Form.Item>
                        <Form.Item
                           label="Prezzo di listino tasse escluse"
                           name="price_sell_no_vat"
                           rules={[]}
                        >
                           <InputNumber
                              size="large"
                              // style={"width= '100%'"}
                              formatter={value => `€ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                              parser={value => value.replace(/\€\s?|(,*)/g, '')}
                              onChange={this.onPriceSellNoVatChange}
                           />
                        </Form.Item> */}
                     <Divider />
                     <Form.Item
                        {...sideLayout}
                        label="Regime IVA"
                        name="tax_rate_id"
                        rules={[]}
                     >
                        <Select
                           showSearch
                           allowClear
                           placeholder="Seleziona il regime IVA"
                           optionFilterProp="children"
                        >
                           {
                              this.state.tax_rates.map((tax) => {
                                 return <Option key={tax.id} value={tax.id}>{tax.name[this.state.componentLanguage]}</Option>
                              })
                           }
                        </Select>
                     </Form.Item>
                     {
                        this.state.formValues.is_parent ? (
                           <Form.Item
                              {...sideLayout}
                              label="Tipo di prezzo"
                              name="price_on_variation">
                              <Radio.Group
                                 onChange={this.handlePriceTypeChange}>
                                 <Radio.Button value={false}>Su prodotto padre</Radio.Button>
                                 <Radio.Button value={true}>Su varianti</Radio.Button>
                              </Radio.Group>
                           </Form.Item>
                        ) : null
                     }
                     {
                        !this.state.formValues.is_parent || !this.state.formValues.price_on_variation ? [
                           <Form.Item
                              {...sideLayout}
                              label="Prezzo su richiesta"
                              key="price_on_request"
                              name="price_on_request">
                              <Radio.Group
                                 onChange={this.handlePriceOnRequestChange}>
                                 <Radio.Button value={false}>Prezzo indicato</Radio.Button>
                                 <Radio.Button value={true} disabled>Prezzo su richiesta</Radio.Button>
                              </Radio.Group>
                           </Form.Item>,
                           !this.state.formValues.price_on_request ? ([
                              <Form.Item
                                 key='price_retail_no_vat'
                                 {...sideLayout}
                                 label="Prezzo di listino (tasse escluse)"
                                 name="price_retail_no_vat"
                                 rules={[]}
                              >
                                 <InputNumber
                                    decimalSeparator=','
                                    precision={2}
                                    // style={"width= '100%'"}
                                    // formatter={value => `€ ${value}`}
                                    // parser={value => value.replace('€ ', '')}
                                    onChange={this.onPriceRetailChange}
                                 />
                              </Form.Item>,
                              <Form.Item
                                 key='price_buy_no_vat'
                                 {...sideLayout}
                                 label="Prezzo di acquisto (tasse escluse)"
                                 name="price_buy_no_vat"
                                 rules={[]}
                              >
                                 <InputNumber
                                    decimalSeparator=','
                                    precision={2}
                                    // style={"width= '100%'"}
                                    // formatter={value => `€ ${value}`}
                                    // parser={value => value.replace('€ ', '')}
                                    onChange={this.onPriceBuyChange}
                                 />
                              </Form.Item>
                           ]) : null
                        ] : null
                     }
                     <Divider key='shipment_divider' />
                     <Form.Item
                        key='pieces_per_pack'
                        {...sideLayout}
                        label="Pezzi per confezione"
                        name="pieces_per_pack"
                        rules={[]}
                     >
                        <InputNumber
                           precision={0}
                           max={65000}
                        />
                     </Form.Item>
                     {
                        !this.state.formValues.is_parent ? [
                           <Form.Item
                              key='weight'
                              {...sideLayout}
                              label="Peso (KG)"
                              name="weight"
                              rules={[]}
                           >
                              <InputNumber
                                 decimalSeparator=','
                                 precision={2}
                              />
                           </Form.Item>,
                           <Form.Item
                              key='length'
                              {...sideLayout}
                              label="Lunghezza (m)"
                              name="length"
                              rules={[]}
                           >
                              <InputNumber
                                 decimalSeparator=','
                                 precision={6}
                              />
                           </Form.Item>,
                           <Form.Item
                              key='height'
                              {...sideLayout}
                              label="Altezza (m)"
                              name="height"
                              rules={[]}
                           >
                              <InputNumber
                                 decimalSeparator=','
                                 precision={6}
                              />
                           </Form.Item>,
                           <Form.Item
                              key='width'
                              {...sideLayout}
                              label="Profondità (m)"
                              name="width"
                              rules={[]}
                           >
                              <InputNumber
                                 decimalSeparator=','
                                 precision={6}
                              />
                           </Form.Item>
                        ] : null
                     }
                  </Col>
               </Row>
               <Row>
                  <Col span={24}>

                     <Tabs size="large">
                        {
                           this.state.formValues.use_stocks ? tabWarehouse : null
                        }
                        {/* <TabPane tab="File allegati" key="files">
                           <Row gutter={[16, 16]}>
                              <Col span={12}>
                                 <Title level={4}>File allegati</Title>
                                 <Table {...filesTableLayout} columns={filesTableColumns} dataSource={this.state.formValues.file_list} />
                              </Col>
                              <Col span={12}>
                                 <Title level={4}>Aggiungi file</Title>
                                 {
                                    this.state.fileUploadWarnings.length ?
                                       <Alert
                                          message="Attenzione"
                                          description={<List
                                             size="small"
                                             dataSource={this.state.fileUploadWarnings}
                                             renderItem={item => <List.Item className='padding-0-I'>{item}</List.Item>}
                                          />}
                                          type="warning"
                                          showIcon
                                          closable
                                       /> : ''
                                 }
                                 <div>
                                    <Dragger {...fileUploadProps}>
                                       <p className="ant-upload-drag-icon">
                                          <InboxOutlined />
                                       </p>
                                       <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                       <p className="ant-upload-hint">
                                          Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                                          band files
                                       </p>
                                    </Dragger>
                                    <Form.Item
                                       label="Tipo di file"
                                       name="media_internal_type_id"
                                    >
                                       <Select
                                          showSearch
                                          placeholder="Seleziona il tipo di file"
                                          optionFilterProp="children"
                                          onChange={this.handleFileTypeSelect}
                                       >
                                          {
                                             this.state.file_types.map((map) => {
                                                return <Option key={map.id} value={map.id}>{map.name}</Option>
                                             })
                                          }
                                       </Select>
                                    </Form.Item>
                                 </div>
                                 <Button
                                    type="primary"
                                    disabled={!this.state.fileUploadList.length}
                                    loading={this.state.loaderAddFiles}
                                    onClick={() => this.handleAddFiles()}
                                 >Aggiungi</Button>
                              </Col>
                           </Row>
                        </TabPane> */}
                        {/* {tabPrices} */}
                        {/* <TabPane tab="Immagini" key="4">
                           <Row gutter={[16, 16]}>
                              <Col span={6}>
                                 <Title level={4}>Galleria immagini</Title>
                                 <DragSortingUpload
                                    images={this.state.formValues.gallery}
                                    imagesOrderSave={(images) => this.handleImagesOrderSave(images)}
                                    loaderOrderSave={this.state.loaderOrderSave}
                                    imageDelete={(imageId) => this.handleImageDelete(imageId)}
                                    loaderImageDelete={this.state.loaderImageDelete}
                                 />
                              </Col>
                              <Col span={12} offset={6}>
                                 <Title level={4}>Aggiungi immagini</Title>
                                 {
                                    this.state.imageUploadWarnings.length ?
                                       <Alert
                                          message="Attenzione"
                                          description={<List
                                             size="small"
                                             dataSource={this.state.imageUploadWarnings}
                                             renderItem={item => <List.Item className='padding-0-I'>{item}</List.Item>}
                                          />}
                                          type="warning"
                                          showIcon
                                          closable
                                       /> : ''
                                 }
                                 <div>
                                    <Dragger {...imageUploadProps}>
                                       <p className="ant-upload-drag-icon">
                                          <InboxOutlined />
                                       </p>
                                       <p className="ant-upload-text">Click or drag file to this area to upload</p>
                                       <p className="ant-upload-hint">
                                          Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                                          band files
                                       </p>
                                    </Dragger>
                                 </div>
                                 <Button
                                    type="primary"
                                    disabled={!this.state.imageUploadList.length}
                                    loading={this.state.loaderAddImages}
                                    onClick={() => this.handleAddImages()}
                                 >Aggiungi</Button>
                              </Col>
                           </Row>
                        </TabPane> */}
                        {/* {tabAnalysis} */}
                     </Tabs>
                  </Col>
               </Row>

               <Form.Item label="language" name="language" noStyle><Input type="hidden" /></Form.Item>
            </Form >

         </Card>

      );


      // const specific_prices_columns = [
      //    {
      //    title: 'Nazione',
      //    dataIndex: 'country',
      //    key: 'country'
      //    },
      //    {
      //       title: 'Ecommerce',
      //       dataIndex:
      //    }
      // ]


      const pageContent = (
         <div className="card">
            <div className="card-header">
               <div className="row">
                  <div className="col-sm-6">
                     <Title level={5}>{languageManager.getMessage(this.props.commonState, 'component.products.title')}</Title>
                  </div>
                  <div className="col-sm-6">
                     {/* <div className="float-right d-none d-md-block">
                        <Space>
                           <Select
                              showSearch
                              className="width-70px-I"
                              placeholder="Seleziona la lingua"
                              optionFilterProp="children"
                              onChange={this.setDefaultLanguageHandler}
                           >
                              {
                                 this.props.authState.userData.languages.map((lang) => {
                                    return <Option key={lang.value} value={lang.value}>{lang.label}</Option>
                                 })
                              }
                           </Select>
                        </Space>
                     </div> */}
                  </div>
               </div>
            </div>
            <div className="card-body">
               {form}
            </div>
            <div className="card-footer">
               <div className="align-items-center row">
                  <div className="col-sm-6">
                     <Space size='small'>
                        <Link to={{ pathname: "/products/list" }} >
                           <Button icon={<DoubleLeftOutlined />}>
                              {languageManager.getMessage(this.props.commonState, 'common.back')}
                           </Button>
                        </Link>
                     </Space>
                  </div>

                  <div className="col-sm-6">
                     <div className="float-right d-none d-md-block">

                        <Space>
                           <Button onClick={this.handleResetForm} disabled={this.state.formLoader}>Annulla</Button>
                           <Button form="createProduct" type="primary" htmlType="submit" loading={this.state.formLoader}>Salva</Button>
                           <Button form="createProduct" type="primary" htmlType="submit" onClick={this.handleSaveAndClose} loading={this.state.formLoader}>Salva e chiudi</Button>
                        </Space>

                     </div>
                  </div>
               </div>
            </div>
         </div>
      );

      return (
         <div className="container-fluid">
            <div className="row">
               <div className="col">
                  {this.state.pageLoader ? <Loader /> : pageContent}
               </div>
            </div>
         </div>

      );
   }
}

const mapStateToProps = state => {
   return {
      authState: state.authenticationState,
      commonState: state.commonState
   };
};


// const mapDispatchToProps = dispatch => {
//     return {
//         onFetchTaxRates: () => dispatch( actions.getTaxRatesList() )

//     };
// };

export default connect(mapStateToProps)(ProductsEdit);